/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventvisibilitymembersdescription3Inputs */

const en_eventvisibilitymembersdescription3 = /** @type {(inputs: Eventvisibilitymembersdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only your members see it and get in.`)
};

const de_eventvisibilitymembersdescription3 = /** @type {(inputs: Eventvisibilitymembersdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur deine Mitglieder sehen es und kommen rein.`)
};

/**
* | output |
* | --- |
* | "Only your members see it and get in." |
*
* @param {Eventvisibilitymembersdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventvisibilitymembersdescription3 = /** @type {((inputs?: Eventvisibilitymembersdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventvisibilitymembersdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventvisibilitymembersdescription3(inputs)
	return de_eventvisibilitymembersdescription3(inputs)
});
export { eventvisibilitymembersdescription3 as "eventVisibilityMembersDescription" }